// Whether any section of the plan form is invalid, as Save checks it.
// `errorIndex` is where the price section scrolls to, not a validity flag.
export const hasInvalidField = (isValid = {}) =>
  Object.keys(isValid).some((key) => key !== 'errorIndex' && !isValid[key]);
